import { giphyBlack } from '@giphy/js-brand'
import { useContext, useEffect } from 'react'
import styled from 'styled-components'
import CreationToolSuperCutField from '../../../types/super-cut-field'
import SelectList from '../../select-list'
import { CreationCaptureInfoContext } from '../../supercut/shared/components/capture-info/manager'
import FieldTitle from './field-title'

const Container = styled.div`
    grid-column: span 1;
    min-width: 0;
`

const UploadNew = styled.div`
    cursor: pointer;
`

type Props = {
    field: CreationToolSuperCutField
}

const CreationCaptureWatermarkField = ({ field }: Props) => {
    const { watermark, setIsWatermarkOpen, previousWatermarks, setPreviousWatermarks, setWatermark } =
        useContext(CreationCaptureInfoContext)

    useEffect(() => {
        if (watermark?.image) {
            setPreviousWatermarks([watermark])
        }
    }, [watermark])

    const onChange = (val: string) => {
        if (watermark?.id === val) {
            setWatermark()
        } else {
            const selected = previousWatermarks.find((wm) => wm.id === val)
            setWatermark(selected)
        }
    }

    return (
        <Container>
            <FieldTitle field={field} />
            <SelectList
                {...{
                    onChange,
                    popUpColor: giphyBlack,
                    value: watermark?.id,
                    options: previousWatermarks.map((wm) => ({
                        value: wm.id,
                        label: wm.title,
                        preview: <img src={wm.image} alt="" />,
                    })),
                }}
            >
                <UploadNew onClick={() => setIsWatermarkOpen(true)}>Upload New</UploadNew>
                <UploadNew onClick={() => setIsWatermarkOpen(true)}>See All</UploadNew>
            </SelectList>
        </Container>
    )
}

export default CreationCaptureWatermarkField
